import React from 'react';
import { useIntl } from 'ha/i18n';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import GoogleIcon from 'ha/custom-icons/google.svg';
import { Button } from '@ha/dsl';

export interface Props {
  searchParams?: Record<string, unknown>;
}

const GoogleAuthBtn: React.FC<Props> = ({ searchParams = {}, children }) => {
  const { urlResolver } = useIntl();
  const link = urlResolver.getGoogleAuthUrl(searchParams);

  return (
    <Track name="Clicked Sign up with Google" type="button">
      <Button
        size="large"
        data-test-locator="Continue with Google"
        href={link}
        startIcon={<GoogleIcon htmlColor="#515e6d" />}
        color="inherit"
        variant="outlined"
        fullWidth
      >
        {children}
      </Button>
    </Track>
  );
};

export { GoogleAuthBtn };
